import { render, staticRenderFns } from "./PICK_features_module_two.vue?vue&type=template&id=f6c4916c&"
import script from "./PICK_features_module_two.vue?vue&type=script&lang=js&"
export * from "./PICK_features_module_two.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports